import { useMainStore } from "../../store/mainStore.js";

export const resetAlerter = async () => {
  (await indexedDB.databases()).forEach((database) =>
    indexedDB.deleteDatabase(database.name)
  );

  window.localStorage.clear();

  useMainStore().$reset();

  await window.api?.writeConfiguration?.({
    configuration: { activatedAt: undefined, productKey: undefined },
  });

  window.location.reload();
};
